import parse from 'html-react-parser';
import Dompurify from 'isomorphic-dompurify';

const SsrElement = ({ html }) => {
  // This is needed because with dangerouslySetInnerHTML alone I can't reproduce the same structure
  // Specifically the nesting of the elements, since dangerouslySetInnerHTML will wrap the html in a div
  // If only react had a createElementFromHTML method or dangerouslySetOuterHTML :/
  return parse(
    Dompurify.sanitize(html, {
      ADD_TAGS: ['script', 'style'],
    }),
  );
};

export default SsrElement;
